import React from "react";
import { useSelector } from "react-redux";
import { Outlet, Navigate } from "react-router-dom";

// Role gate for the /admindashboard/* routes. Nests inside AuthRoutes, so by the
// time this renders the user is already known to be logged in -- this only
// answers "are they an Admin".
//
// This is a UI gate, not the security boundary: state.user comes from the client
// and the real check is server-side (isAdmin in server/middleware/auth.js). It
// exists so admin tooling doesn't render for non-admins at all, rather than
// rendering a shell whose data calls 403.
export default function AdminRoutes() {
  const user = useSelector((state) => state.user);
  const authChecked = useSelector((state) => state.authStatus.checked);

  // Same reason as AuthRoutes: AuthBootstrap restores the session (and with it
  // the role) asynchronously on a hard refresh. Redirecting before that lands
  // would bounce a real admin off their own dashboard.
  if (!authChecked) return null;

  return user?.role === "Admin" ? <Outlet /> : <Navigate to="/accessdenied" replace />;
}
